import { CapexPlanResult } from "../Data/CapexPlan";
import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { styled } from "@mui/system";

interface CapexLocationNameRowProps {
  capexPlanResult: CapexPlanResult[];
}

const CustomTableCell = styled(TableCell)({
  padding: "9px", // Adjust the padding as needed
  backgroundColor: "#E9EFF5",
});

const CapexLocationNameRow: React.FC<CapexLocationNameRowProps> = ({
  capexPlanResult,
}: CapexLocationNameRowProps): React.ReactElement => (
  <TableRow>
    <CustomTableCell>Locations</CustomTableCell>
    {capexPlanResult.map((item) => (
      <CustomTableCell key={`capex-${item.capexModelCost.locationName}`}>
        {item.capexModelCost.locationName}
      </CustomTableCell>
    ))}
  </TableRow>
);

export default CapexLocationNameRow;
